export const validateField = (name: string, value: string) => {
  switch (name) {
    case 'clientId':
      if (value.length < 5) {
        return 'Client ID must be at least 5 characters long';
      } else if (!/^[a-zA-Z0-9_-]+$/.test(value)) {
        return 'Client ID can only contain alphabets, hyphens (-), and underscores (_)';
      }
      break;
    case 'owner':
      const ownerPattern = /component\//;
      if (!ownerPattern.test(value)) {
        return 'Owner must be in the format "backStageComponent | component/component-id"';
      }
      break;
    default:
      return '';
  }
};
